module.exports = __webpack_public_path__ + "img/Sebastien.fa8205db.jpg";